import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/location-groups/$locationGroupId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/warehouses/$locationGroupId',
      params: { locationGroupId: params.locationGroupId },
      replace: true,
    });
  },
});
